import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef, useState, useEffect } from "react";

import NudgeCardComponent from "../NudgeCardComponent";
import { INudgesActionProps, useActionOnNudgesAPI } from "@/app/hooks/api_hooks/nudges/useActionOnNudgesAPI";
import { useAppDispatch, useAppSelector } from "@/app_redux/hooks/root_hook";
import { IClickLogBody, useClickLogAPI } from "@/app/hooks/api_hooks/org/useClickLogAPI";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useNewCartAPI } from "@/app/hooks/api_hooks/Cart/useNewCartAPI";
import {
  INudgesCartMedicineProps,
  useFoodOnNudgeActionInCartAPI,
} from "@/app/hooks/api_hooks/nudges/useFoodOnNudgeActionInCartAPI";
import toast from "react-hot-toast";
import {
  INudgesEscalationTicketProps,
  useEscalationTicketOnNudgeAPI,
} from "@/app/hooks/api_hooks/nudges/useEscalationTicketOnNudgeAPI";
import { useServiceDeskCreateRaiseAPI } from "@/app/hooks/api_hooks/service_desk/useServiceDeskCreateRaiseAPI";

const NudgesModalContainer = ({
  nudge,
  source,
  customer_id,
  addMembershipAndFoodInCart,
  handelAddFoodAndMedicine,
  handelCheckoutFunction,
  alert_category_list,
  pet_Id,
  setCheckoutNudge,
  journey_point,
  setIsNotPreferedDoctorNudgeOpen,
}) => {
  const isVaccinationNudge = nudge?.alert_category_list?.includes("Vaccination Addon");
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { setInvisible } = useModalActions("EMR_SUBMISSION_MODAL");
  const [hasShownToast, setHasShownToast] = useState(false);
  const [initailLoad, setInitailLoad] = useState(false);
  const [isAnimated, setIsAnimated] = useState(false);
  const [colorCode, seColorCode] = useState(null);
  const [nudgePosition, setNudgePosition] = useState<string>("top-right");
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const { execute: actionOnNudges } = useActionOnNudgesAPI();
  const isProcessingRef = useRef(false);
  const { execute: createNewCart } = useNewCartAPI();
  const { execute: addFoodOnCart } = useFoodOnNudgeActionInCartAPI();
  const mappedClinicId = useAppSelector((state) => state.root.UIStates.mappedClinicId);
  const mappedClinicName = useAppSelector((state) => state.root.UIStates.mappedClinicName);
  const { execute: createIssueAPI } = useServiceDeskCreateRaiseAPI();

  const dispatch = useAppDispatch();

  const userLogInfo = useAppSelector((state) => state.auth?.user?.email);
  const { execute: logAPI } = useClickLogAPI();
  const { execute: addEscalationTicketOnNudge } = useEscalationTicketOnNudgeAPI();

  useEffect(() => {
    if (nudge?.name && !initailLoad) {
      if (source === "booking_journey" && nudge?.priority?.toLowerCase() === "high") {
        const colorCode = {
          bg_color: "#FFEAEA",
          border_color: "#E23535",
        };
        seColorCode(colorCode);
        setIsAnimated(false);
        setOpen(true);
      } else if (source === "booking_journey" && nudge?.priority?.toLowerCase() === "medium") {
        const colorCode = {
          bg_color: "#FFF9EE",
          border_color: "#BF7D01",
        };

        seColorCode(colorCode);
        setNudgePosition("top-right");
        setIsAnimated(true);
        setOpen(false);
      } else if (source === "booking_journey" && nudge?.priority?.toLowerCase() === "low") {
        const colorCode = {
          bg_color: "#E7F3FF",
          border_color: "#4EA3F8",
        };

        seColorCode(colorCode);
        setNudgePosition("top-right");
        setIsAnimated(true);
        setOpen(false);
      }

      if ((source === "Cart" || source === "EMR") && nudge?.priority?.toLowerCase() === "high") {
        const colorCode = {
          bg_color: "#FFEAEA",
          border_color: "#E23535",
        };
        seColorCode(colorCode);
        setIsAnimated(false);
        setOpen(true);
      } else if ((source === "Cart" || source === "EMR") && nudge?.priority?.toLowerCase() === "medium") {
        const colorCode = {
          bg_color: "#FFF9EE",
          border_color: "#BF7D01",
        };

        seColorCode(colorCode);
        setNudgePosition("bottom-right");
        setIsAnimated(true);
        setOpen(false);
      } else if ((source === "Cart" || source === "EMR") && nudge?.priority?.toLowerCase() === "low") {
        const colorCode = {
          bg_color: "#E7F3FF",
          border_color: "#4EA3F8",
        };

        seColorCode(colorCode);
        setNudgePosition("bottom-right");
        setIsAnimated(true);
        setOpen(false);
      }

      setInitailLoad(true);
    }
  }, [nudge, initailLoad]);

  useEffect(() => {
    if (source === "PWL" && nudge) {
      if (nudge?.priority?.toLowerCase() === "high") {
        const colorCode = {
          bg_color: "#FFEAEA",
          border_color: "#E23535",
        };
        seColorCode(colorCode);
      } else if (nudge?.priority?.toLowerCase() === "medium") {
        const colorCode = {
          bg_color: "#FFF9EE",
          border_color: "#BF7D01",
        };
        seColorCode(colorCode);
      } else if (nudge?.priority?.toLowerCase() === "low") {
        const colorCode = {
          bg_color: "#E7F3FF",
          border_color: "#4EA3F8",
        };
        seColorCode(colorCode);
      }
    }
  }, [source, nudge]);

  useEffect(() => {
    if (journey_point === "pwl" && nudge) {
      setOpen(true);
      // console.log("nudge active")
    }
  }, [journey_point, nudge]);

  const handelOnNudgeAction = (CTA: string) => {
    if (isProcessingRef.current) return;
    isProcessingRef.current = true;
    setLoader(true);
    // console.log(CTA, "cta clicked");

    if (CTA === "CTA1") {
      const logBody: IClickLogBody = {
        event_type: "NUDGE_CLICKED_1",
        client_id: customer_id,
        pet_id: nudge?.heading_variables?.pet_id,
        vms_user_id: userLogInfo,
        scr_id: source?.toLowerCase(),
        timestamp: Date.now(),
        nudge_type: nudge?.alert_category_list?.length > 0 && nudge?.alert_category_list[0],
        nudge_name: nudge?.name,
        cta1: nudge?.cta_1,
        cta2: nudge?.cta_2,
        cta_text: nudge?.cta_1,
      };
      setIsAnimated(false);
      logAPI(logBody);
    }
    if (CTA === "CTA2") {
      const logBody: IClickLogBody = {
        event_type: "NUDGE_CLICKED_2",
        client_id: customer_id,
        pet_id: nudge?.heading_variables?.pet_id,
        vms_user_id: userLogInfo,
        scr_id: source?.toLowerCase(),
        timestamp: Date.now(),
        nudge_type: nudge?.alert_category_list?.length > 0 && nudge?.alert_category_list[0],
        nudge_name: nudge?.name,
        cta1: nudge?.cta_1,
        cta2: nudge?.cta_2,
        cta_text: nudge?.cta_2,
      };
      logAPI(logBody);
    }
    if (nudge?.alert_category_list?.length > 0 && nudge?.alert_category_list[0] === "Dr Reminder" && CTA === "CTA1") {
      setInvisible();
      return;
    }
    if (nudge?.add_grooming_to_cart && CTA === "CTA1") {
      createNewCart(customer_id, mappedClinicId, mappedClinicName).then((cartId) => {
        if (cartId) {
          const constructedBody: INudgesCartMedicineProps = {
            customer_id: customer_id,
            pet_id: pet_Id,
            cart_id: cartId,
            grooming_membership_list: selectedItems,
            source_type: "service",
            clinic_id: mappedClinicId,
          };

          addFoodOnCart(constructedBody).then(({ status }) => {
            if (status) {
              toast.success("item added in cart");
              setLoader(false);
              setOpen(false);
              setHasShownToast(false);
              setIsAnimated(false);
            }
          });
        }
      });
    }

    if (nudge?.add_food_and_medicine && CTA === "CTA1") {
      handelAddFoodAndMedicine(nudge).then(({ status }) => {
        if (status) setLoader(false);
      });
      return;
    }
    if (nudge?.is_cx_discount && CTA === "CTA1") {
      setCheckoutNudge(false);
      handelCheckoutFunction(nudge?.cta_1?.toLowerCase() === "approved" ? false : true, CTA);
      return;
    }
    if (nudge?.is_cx_discount && CTA === "CTA2") {
      setCheckoutNudge(false);
      handelCheckoutFunction(false, CTA);
      setLoader(false);
      setOpen(false);
      setHasShownToast(false);
      setIsAnimated(false);
    }

    if (nudge?.add_membership && CTA === "CTA1") {
      addMembershipAndFoodInCart(selectedItems, "#membership").then(({ status }) => {
        if (status) {
          setLoader(false);
          setOpen(false);
          setHasShownToast(false);
          setIsAnimated(false);
        }
      });
      return;
    }
    if (nudge?.add_food_to_cart && CTA === "CTA1") {
      addMembershipAndFoodInCart(selectedItems, "#product").then(({ status }) => {
        if (status) {
          setLoader(false);
          setOpen(false);
          setHasShownToast(false);
          setIsAnimated(false);
        }
      });
      return;
    }
    if (nudge?.add_grooming_to_cart && CTA === "CTA1") {
      addMembershipAndFoodInCart(selectedItems, "#service").then(({ status }) => {
        if (status) {
          setLoader(false);
          setOpen(false);
          setHasShownToast(false);
          setIsAnimated(false);
        }
      });
      return;
    }

    if (nudge?.teleconsultation_nudge && CTA === "CTA2") {
      const teleconsultation_nudgePalyload: INudgesEscalationTicketProps = {
        booking_list:
          selectedItems.length > 0 ? selectedItems : nudge?.description_variables?.booking_list_doctor || [],
      };
      addEscalationTicketOnNudge(teleconsultation_nudgePalyload).then(({ status }) => {
        if (status) {
          setLoader(false);
          setOpen(false);
          setHasShownToast(false);
          setIsAnimated(false);
        } else {
          setLoader(false);
        }
      });
      isProcessingRef.current = false;
      return;
    }
    // console.log(nudge);

    if (nudge?.add_vaccine && CTA === "CTA1") {
      setLoader(false);
      window.open(
        `/app/customer/profile/customer-details/vaccination/${customer_id}/${nudge?.heading_variables?.pet_id}?document_source=vaccination_status&&isAddVaccine=ADD_VACCINE`,
        "_blank",
      );
      return;
    }
    const payload: INudgesActionProps = {
      comment: nudge?.comment,
      client_agree: CTA === "CTA1" ? true : false,
      customer_id: customer_id,
      nudge_id: nudge?.nudge_id,
      cta: CTA === "CTA1" ? nudge?.cta_1 : nudge?.cta_2,
      pet_id: nudge?.heading_variables?.pet_id,
      vaccine_list: nudge?.comment_variable_list?.vaccines_with_id,
      grooming_membership_list: nudge?.teleconsultation_nudge ? undefined : selectedItems,
      teleconsultation_list: nudge?.teleconsultation_nudge ? selectedItems : undefined,
    };

    // If this nudge requires escalation ticket creation, call the API
    actionOnNudges(payload).then(({ status }) => {
      if (status) {
        setLoader(false);
        setOpen(false);
        setHasShownToast(false);
        setIsAnimated(false);
      } else {
        isProcessingRef.current = false;
        setLoader(false);
      }
    });

    if (source === "Cart") {
      setCheckoutNudge(false);
      handelCheckoutFunction(nudge?.cta_1?.toLowerCase() === "approved" ? false : true, CTA);
    }
    source === "booking_journey" && CTA === "CTA2" && setIsNotPreferedDoctorNudgeOpen(false, null);
    source === "booking_journey" && CTA === "CTA1" && setIsNotPreferedDoctorNudgeOpen(false, "CLICK");
  };

  return journey_point === "pwl" ? (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-hidden"
        initialFocus={cancelButtonRef}
        onClose={() => console.log("dd")}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          {/* Overlay */}
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
          </Transition.Child>

          {/* Spacer for vertical centering */}
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>

          {/* Modal Panel */}
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom sm:align-middle sm:max-w-2xl sm:w-full text-left transform transition-all">
              <NudgeCardComponent
                nudge={nudge}
                source={source}
                onClose={() => setOpen(false)}
                isWidth={true}
                colorCode={colorCode}
                loader={loader}
                handelOnNudgeAction={handelOnNudgeAction}
                setSelectedItems={setSelectedItems}
                selectedItems={selectedItems}
                customer_id={customer_id}
              />
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  ) : source === "PWL" || (alert_category_list?.length > 0 && alert_category_list[0] === "Dr Reminder") ? (
    <NudgeCardComponent
      nudge={nudge}
      source={source}
      onClose={() => setOpen(false)}
      isWidth={true}
      colorCode={colorCode}
      loader={loader}
      handelOnNudgeAction={handelOnNudgeAction}
      setSelectedItems={setSelectedItems}
      selectedItems={selectedItems}
      customer_id={customer_id}
    />
  ) : (
    <>
      {isAnimated && (
        <div className="fixed top-4 right-10 z-50  max-w-full">
          {/* <Toast className="w-full !bg-transparent shadow-none p-0"> */}
          <div className="flex items-start gap-4 w-full">
            <div className="flex-1 text-sm">
              <NudgeCardComponent
                nudge={nudge}
                source={source}
                onClose={() => setOpen(false)}
                isWidth={true}
                colorCode={colorCode}
                loader={loader}
                handelOnNudgeAction={handelOnNudgeAction}
                setSelectedItems={setSelectedItems}
                selectedItems={selectedItems}
                customer_id={customer_id}
              />
            </div>
          </div>
          {/* </Toast> */}
        </div>
      )}

      {!isAnimated && (
        <Transition.Root show={open} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-50 overflow-hidden"
            initialFocus={cancelButtonRef}
            onClose={() => console.log("dd")}
          >
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
              {/* Overlay */}
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
              </Transition.Child>

              {/* Spacer for vertical centering */}
              <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                &#8203;
              </span>

              {/* Modal Panel */}
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <div className={`inline-block align-bottom sm:align-middle text-left transform transition-all ${isVaccinationNudge ? "w-[392px]" : "sm:max-w-2xl sm:w-full"}`}>
                  <NudgeCardComponent
                    nudge={nudge}
                    source={source}
                    onClose={() => setOpen(false)}
                    isWidth={true}
                    colorCode={colorCode}
                    loader={loader}
                    handelOnNudgeAction={handelOnNudgeAction}
                    setSelectedItems={setSelectedItems}
                    selectedItems={selectedItems}
                    customer_id={customer_id}
                  />
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>
      )}
    </>
  );
};

export default NudgesModalContainer;
